import { render, staticRenderFns } from "./bgtsList.vue?vue&type=template&id=41e56f94&"
import script from "./bgtsList.vue?vue&type=script&lang=js&"
export * from "./bgtsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports